export const DEFAULT_CHANGE_DELAY = 500
